import FarmbookHeader from '@/components/farmbookHeader'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import { PAGE_TYPE, STRINGS } from '@/constants/farmbook'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const Video = () => {
  return (
    <LayoutWithNavigation>
      <section className="px-6 my-4 max-w-7xl m-auto">
        <FarmbookHeader activePage={PAGE_TYPE.VIDEOS} />
        <iframe
          className="aspect-[2] w-full md:w-2/3 mt-[30px]"
          src="https://www.youtube.com/embed/?listType=playlist&amp;list=PL_fEi6pdr_fV6lvBUasQfmWj2ZfiAs1QS"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </section>
    </LayoutWithNavigation>
  )
}

export default Video
